module.exports = __webpack_public_path__ + "static/media/06.4692ebd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/06.jpg
// module id = 696
// module chunks = 0